<app-header></app-header>

<app-side-nav (sidebarToggled)="onSidebarToggled($event)"></app-side-nav>

<div class="main-content" [class.sidebar-collapsed]="sidebarCollapsed">
  <router-outlet></router-outlet>
  
  @if (isLoading()) {
    <div class="spinner-wrapper">
      <mat-spinner class="spinner main"></mat-spinner>
    </div>
  }
</div>